import React, { useEffect, useState } from 'react';

export const TRANSITION_DURATION = 200;

export const useTransition = (component: React.ReactNode, currentQuestionIndex: number) => {
  const targetKey = `q-${currentQuestionIndex}`;

  const [visible, setVisible] = useState(true);
  const [displayedKey, setDisplayedKey] = useState<string>(targetKey);
  const [displayedNode, setDisplayedNode] = useState<React.ReactNode>(component);

  useEffect(() => {
    if (targetKey === displayedKey) return;

    setVisible(false);

    const timeout = window.setTimeout(() => {
      setDisplayedNode(component);
      setDisplayedKey(targetKey);
      setVisible(true);
    }, TRANSITION_DURATION);

    return () => window.clearTimeout(timeout);
  }, [targetKey, component, displayedKey]);

  return { visible, displayedNode };
};
